<template>
<div class="col-xs-12">
  <div class="card float-e-margins">
    <div class="card-title">
        <h1>Gebruikersteller</h1>
    </div>
    <div class="card-content no-padding">
      <div class="table-responsive">
        <div class="card-title card-header form-horizontal">
          <div class="form-group">
            <label class="control-label col-sm-1" style="text-align:left;" for="filter">Filter op : </label>
            <div class="col-sm-4">
              <input type="text" class="form-control" id="filter" placeholder="Filter" v-model="filterKey">
            </div>
          </div>
        </div>
        <div class="col-md-12 text-right" style="background:white;">
          <div class="form-inline">
              <datepicker language="nl" :disabled="datepicker.disabled" placeholder="Begindatum"
              :value.sync="selectedStartDate" name="updatedBegin"></datepicker>
              <datepicker language="nl" :disabled="datepicker.disabled" placeholder="Einddatum"
              :value.sync="selectedEndDate" name="updatedEnd"></datepicker>
             
              <button type="button" class="btn btn-primary" :class="{ 'active' : isSelectedButton(0) }"
               @Click="period = 'Day', getAnalystics(period), selectedButton = 0">
                Dagelijks
              </button>
              <button type="button" class="btn btn-primary" :class="{ 'active' : isSelectedButton(1) }"
               @Click="period = 'Month', getAnalystics(period), selectedButton = 1">
                Maandelijks
              </button>
              <button type="button" class="btn btn-primary" :class="{ 'active' : isSelectedButton(2) }" 
              @Click="period = 'Year', getAnalystics(period), selectedButton = 2">
                Jaarlijks
              </button>
          </div>
          <div class="chart" v-echarts="barChartOption" :loading="barChartLoading"></div>
        </div>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th v-for="(key, val) in columns">
                <a @click="sortBy(val)" class="arrow">
                  {{ key | capitalize }}
                </a>
              </th>
          </thead>
          <tbody>
            <tr v-for="analystic in analystics | filterBy filterKey | orderBy sortKey reverse">
              <td>
                <p v-else style="white-space:pre-line;"><small>{{ analystic.Day }}</small></p>
              </td>
              <td>
                <p v-else style="white-space:pre-line;"><small>{{ analystic.DateSubmitted }}</small></p>
              </td>
              <td>
                <p v-else style="white-space:pre-line;"><small>{{ analystic.Value }}</small></p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import store from '../../store'
import datepicker from '../datepicker/Datepicker'
export default {
  route: {
    canReuse: false
  },
  components: {
    datepicker
  },
  data () {
    return {
      store: store,
      analystics: {},
      columns: {
        'Dag': 'Day',
        'Datum': 'Date',
        'Aantal Gebruikers': 'Value'
      },
      sortKey: '',
      reverse: 1,
      showdeltemodal: false,
      filterKey: '',
      showCustomModal: false,
      edit: false,
      barChartLoading: true,
      barChartOption: null,
      selectedStartDate: null,
      selectedEndDate: new Date(),
      selectedButton: 0,
      period: '',
      datepicker: {
        disabled: {
          to: new Date(2016, 9, 4)
        }
      }
    }
  },
  created () {
    var self = this
    self.selectedStartDate = self.getPrevWeek()
    self.barChartOption = {
      backgroundColor: 'rgb(249, 249, 249)',
      color: ['#ad1457', '#7F4757'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#48b',
            width: 2,
            type: 'solid'
          },
          crossStyle: {
            color: '#1e90ff',
            width: 1,
            type: 'dashed'
          },
          shadowStyle: {
            color: 'rgba(150,150,150,0.3)',
            width: 'auto',
            type: 'default'
          }
        }
      },
      toolbox: {
        show: true,
        feature: {
          dataZoom: {
            yAxisIndex: 'none',
            title: {
              zoom: 'selecteren',
              back: 'herstel'
            }
          },
          magicType: {
            show: true,
            title: {
              line: 'lijn',
              bar: 'staaf'
            },
            type: ['line', 'bar']
          },
          saveAsImage: {
            show: true,
            title: 'opslaan',
            type: 'png',
            name: 'catootjeskraam_gebruikers',
            pixelRatio: 10
          }
        }
      },
      xAxis: {
        data: []
      },
      yAxis: {},
      series: [
        {
          name: 'Gebruikers',
          type: 'line',
          data: [],
          markPoint: {
            data: [
              {type: 'max', name: 'max'},
              {type: 'min', name: 'min'}
            ]
          }
        }
      ],
      dataZoom: {
        show: true,
        start: 0,
        end: 100
      }
    }
    self.getAnalystics()
  },
  ready () {
    var self = this
    self.$on('datepicker.updatedBegin', (val) => {
      self.getAnalystics(self.period)
    })
    self.$on('datepicker.updatedEnd', (val) => {
      self.getAnalystics(self.period)
    })
  },
  methods: {
    getAnalystics (period) {
      var self = this
      self.barChartLoading = true
      var startDate = 'startdate=' + self.formatDate(self.selectedStartDate, 'yyyy-MM-dd') + '&'
      var endDate = 'enddate=' + self.formatDate(self.selectedEndDate, 'yyyy-MM-dd') + '&'
      period = 'period=' + period
      var query = startDate + endDate + period
      $.ajax({
        type: 'GET',
        url: store.root + 'api/Analystics?' + query,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function (response) {
        self.analystics = response
        self.fillChart(self.analystics)
      }).fail(function (response) {
        self.success = false
        self.error = true
        self.loaded = false
      })
    },
    fillChart (response) {
      var self = this
      var reveredResponse = response.slice(0)
      reveredResponse.reverse()
      self.barChartOption.xAxis.data = []
      self.barChartOption.series[0].data = []
      for (var j = 0; j < reveredResponse.length; j++) {
        self.barChartOption.xAxis.data.push(reveredResponse[j].DateSubmitted)
        self.barChartOption.series[0].data.push(parseInt(reveredResponse[j].Value))
      }
      self.barChartLoading = false
    },
    sortBy (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? this.reverse * -1 : -1
      this.sortKey = sortKey
    },
    isSelectedButton (i) {
      var self = this
      return i === self.selectedButton
    },
    getPrevWeek () {
      var datetimer = new Date()
      var res = datetimer.setDate(datetimer.getDate() - 7)
      return new Date(res)
    },
    formatDate (date, format) {
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let str = format
        .replace(/yyyy/, year)
        .replace(/yy/, String(year).slice(2))
        .replace(/MM/, ('0' + month).slice(-2))
        .replace(/M(?!a)/, month)
        .replace(/dd/, ('0' + day).slice(-2))
        .replace(/d/, day)
      return str
    }
  }
}
</script>

<style scoped>
  .chart {
    width: 100%;
    height: 400px;
}
</style>


// WEBPACK FOOTER //
// analytics.vue?e912c596